export default theme => ({
  title: {
    float: 'right',
    color: '#666',
    fontSize: 20,
    fontWeight: 'bold',
    background: '#ffffff',
    padding: '0 10px 0 10px',
    marginTop: 16,
    marginBottom: 0,
  },
  titleLine: {
    position: 'relative',
    left: 0,
    right: 0,
    top: '40%',
    margin: '20px 0 30px',
    height: 0,
    borderBottom: '1px solid #ececec',
    paddingBottom: 35,
  },
  comment: {
    color: '#424953',
    padding: 10,
    border: '1px solid #E0E0E0',
    margin: '10px 0 10px 0',
    boxShadow: '1px 1px 3px #F5F5F5',
    background: '#fcfcfc',
    borderRadius: 2,
    marginBottom: '1em',
    fontSize: 12,
  },
  commentAuthor: {
    fontSize: '0.90rem',
    fontWeight: 'bold',
    color: '#fc4a38',
    margin: '0 10px 5px 0',
  },
  messageRoot: {
    padding: 0,
  },
  message: {
    paddingTop: 0,
    minHeight: 140,
    fontSize: 12
  },
  inputRoot: {
    paddingRight: 0,
    paddingTop: 0,
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
  input: {
    fontSize: 12,
  },
  sendButtonWrapper: {
    textAlign: 'left',
  },
  sendButton: {
    backgroundColor: '#666',
    color: '#fff',

    '&:hover': {
      backgroundColor: '#fc4a38'
    }
  },
  sendButtonFormControl: {
    paddingLeft: 0
  },

  messages: {
    color: '#45b10e',
  },
  replyTo: {
    border: '1px solid #ccc',
    background: '#eee',
    marginBottom: 10,
    padding: '5px 8px',
    fontSize: 12,
    color: '#424953',
    borderRight: '3px solid #45b10e',
  },
  replyTarget: {
    color: '#fc4a38',
    cursor: 'pointer',
    fontWeight: 'bold',
    marginRight: 5,
    marginLeft: 5,
    '&:visited': {
      color: '#fc4a38',
    }
  },
  replyCancel: {
    cursor: 'pointer',
    marginRight: 5,
    borderBottom: '1px dotted #000',
  }
});